module.exports = __webpack_public_path__ + "static/media/wb_api_key_page.daa6f046.png";